import { useState } from "react";
import { Box, Container, Typography } from "@mui/material";
import Header from "./Header";
import Search from "./Search";
import Results from "./Results";
import { API_BASE_URL, fetchJson } from "./api";

function App() {
  const [search, setSearch] = useState(false);
  const [data, setData] = useState(false);
  const [query, setQuery] = useState(false);

  const handleSearch = async (params) => {
    setSearch(false); // re-renders datagrid to reset values between searches
    const qString = `${API_BASE_URL}${params}&page=0&limit=10`;
    const data = await fetchJson(qString);
    setQuery(qString);
    setData(data);
    setSearch(true);
  };

  const handleEmpty = () => {
    setSearch(false);
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Header />
      <Box component="main" sx={{ flex: 1 }}>
        <Container maxWidth="md" sx={{ pt: { xs: 3, sm: 5 }, pb: 2 }}>
          <Typography
            color="text.secondary"
            sx={{ mb: 3, maxWidth: 600, fontSize: "1.05rem" }}
          >
            Hae henkilöitä ja paikkoja indeksoitujen henkikirjojen sisällöistä.
            Hakutuloksista pääset suoraan digitoidun henkikirjan sivulle
            Kansallisarkiston Astia-palvelussa.
          </Typography>
          <Search handleSearch={handleSearch} handleEmpty={handleEmpty} />
        </Container>
        {search && data && (
          <Container maxWidth="lg" sx={{ pb: 2 }}>
            <Results
              search={search}
              handleSearch={handleSearch}
              data={data}
              query={query}
            />
          </Container>
        )}
      </Box>
      <Box
        component="footer"
        sx={{ borderTop: 1, borderColor: "divider", mt: 4, py: 3 }}
      >
        <Typography align="center" variant="body2" color="text.secondary">
          © Suomen Sukututkimusseura 2023
        </Typography>
      </Box>
    </Box>
  );
}

export default App;
